(function () {
  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.from(root.querySelectorAll(sel)); }

  document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('.egm-qof');
    if (!root) return;

    const list = qs(root, '[data-qof-list]');
    if (!list) return;

    const searchInput = qs(root, '.egm-qof__search-input');
    const discountBtn = qs(root, '[data-filter="discount"]');
    const discountTag = (root.dataset.discountTag || '').trim();

    const addBtn = qs(root, '[data-qof-add]');
    const clearBtn = qs(root, '[data-qof-clear]');
    const countEl = qs(root, '[data-qof-count]');

    const toggleOpenLabel = (root.dataset.toggleOpenLabel || 'Choose variant').trim();
    const toggleCloseLabel = (root.dataset.toggleCloseLabel || 'Close').trim();
    const orderingLabel = (root.dataset.orderingLabel || 'ORDERING…').trim();

    const lineAddLabel = (root.dataset.lineAddLabel || 'Add to order').trim();
    const lineAddingLabel = (root.dataset.lineAddingLabel || 'Adding…').trim();
    const lineAddedLabel = (root.dataset.lineAddedLabel || 'Added').trim();

    const addDefaultLabel = addBtn ? addBtn.textContent.trim() : 'ORDER';

    // Show more
    const moreWrap = qs(root, '[data-qof-morewrap]');
    const moreBtn = qs(root, '[data-qof-more]');
    const initialVisible = Math.max(1, parseInt(root.dataset.initialVisible || '3', 10) || 3);
    let expanded = false;

    let cartCount = 0; // carrello reale (item_count)

    function getRows() { return qsa(list, '[data-qof-row]'); }

    function setToggleState(btn, expandedState) {
      btn.setAttribute('aria-expanded', expandedState ? 'true' : 'false');
      btn.textContent = expandedState ? toggleCloseLabel : toggleOpenLabel;
    }

    // =========================
    // STOCK helpers (clamp quantity to available stock)
    // =========================
    function getVariantMax(variantEl){
      if (!variantEl) return null;
      const stockEl = variantEl.querySelector('.egm-qof__variant-stock .egm-qof__stocknum');
      if (!stockEl) return null;
      const raw = (stockEl.textContent || '').trim();
      if (!raw || raw === '—' || raw === '-') return null;
      const n = parseInt(raw.replace(/[^0-9]/g, ''), 10);
      if (!Number.isFinite(n)) return null;
      return n;
    }

    function clampVariantQty(variantEl, qty){
      let n = parseInt(qty, 10);
      if (!Number.isFinite(n)) n = 0;
      if (n < 0) n = 0;

      const max = getVariantMax(variantEl);
      if (max != null && n > max) n = max;

      return n;
    }

    /* =========================
       CART UI UPDATE (badge + drawer)
       ========================= */
    function updateCartBadges(count) {
      const selectors = [
        '[data-cart-count]','[data-cart-items]','[data-cart-items-count]',
        '.thb-item-count','.cart-count-bubble__count','.cart-link__bubble',
        '.cart-count','.CartCount','.header-cart-count','.float_count'
      ];
      selectors.forEach((sel) => {
        document.querySelectorAll(sel).forEach((el) => {
          el.textContent = String(count);
          if (el.hasAttribute('data-cart-count')) el.setAttribute('data-cart-count', String(count));
          if (el.hasAttribute('data-cart-items')) el.setAttribute('data-cart-items', String(count));
          if (el.hasAttribute('data-cart-items-count')) el.setAttribute('data-cart-items-count', String(count));
        });
      });
    }

    function getSectionsToRender() {
      return [
        { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
        { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' }
      ];
    }

    function getSectionInnerHTML(html, selector) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const el = doc.querySelector(selector || '.shopify-section');
      return el ? el.innerHTML : '';
    }

    function renderCartContents(sectionsObj) {
      getSectionsToRender().forEach((section) => {
        const container = document.getElementById(section.id);
        if (!container) return;

        const elementToReplace = container.querySelector(section.selector) || container;
        const sectionHTML = sectionsObj[section.section];
        if (!sectionHTML) return;

        elementToReplace.innerHTML = getSectionInnerHTML(sectionHTML, section.selector);

        if (typeof window.CartDrawer !== 'undefined') new window.CartDrawer();
        if (typeof window.Cart !== 'undefined') new window.Cart().renderContents({ sections: sectionsObj });
      });
    }

    async function refreshCartUI() {
      try {
        const [cartRes, sectionsRes] = await Promise.all([
          fetch('/cart.js', { headers: { 'Accept': 'application/json' } }),
          fetch('/?sections=cart-drawer,main-cart', { headers: { 'Accept': 'application/json' } })
        ]);

        const cart = await cartRes.json().catch(() => null);
        const sections = await sectionsRes.json().catch(() => null);

        if (cart && typeof cart.item_count !== 'undefined') {
          cartCount = Number(cart.item_count) || 0;

          if (window.Shopify && typeof window.Shopify.onCartUpdate === 'function') {
            window.Shopify.onCartUpdate(cart);
          } else {
            updateCartBadges(cartCount);
          }

          document.dispatchEvent(new CustomEvent('egm:cart-updated', { detail: cart }));
        }

        if (sections) renderCartContents(sections);
      } catch (e) {
        console.warn('Cart refresh failed', e);
      }
    }

    /* =========================
       SHOW MORE LIMIT (after filters)
       ========================= */
    function applyLimit() {
      if (!moreWrap || !moreBtn) return;

      const rows = getRows();
      const matched = rows.filter(r => (r.dataset.qofMatch || '1') === '1');

      // reset any limit-hiding first (for matched)
      matched.forEach(r => { r.dataset.qofLimited = '0'; });

      if (matched.length <= initialVisible) {
        moreWrap.hidden = true;
        return;
      }

      moreWrap.hidden = false;

      if (!expanded) {
        matched.forEach((row, idx) => {
          if (idx >= initialVisible) {
            row.style.display = 'none';
            row.dataset.qofLimited = '1';
          } else {
            row.style.display = '';
            row.dataset.qofLimited = '0';
          }
        });
        moreBtn.textContent = moreBtn.dataset.more || 'SHOW MORE';
      } else {
        matched.forEach(row => { row.style.display = ''; row.dataset.qofLimited = '0'; });
        moreBtn.textContent = moreBtn.dataset.less || 'SHOW LESS';
      }
    }

    moreBtn?.addEventListener('click', () => {
      expanded = !expanded;
      applyFilters(); // re-render visibilità (filtri + limit)
    });

    /* =========================
       TOGGLE accordion
       ========================= */
    list.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-qof-toggle]');
      if (!toggle) return;

      const row = toggle.closest('[data-qof-row]');
      const variants = qs(row, '[data-qof-variants]');
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';

      variants.hidden = isOpen;
      setToggleState(toggle, !isOpen);
    });

    /* =========================
       QTY + / -
       ========================= */
    list.addEventListener('click', (e) => {
      const btn = e.target.closest('.egm-qof__qtybtn');
      if (!btn) return;

      const wrap = btn.closest('[data-qof-variant]');
      if (!wrap) return;

      const input = qs(wrap, '.egm-qof__qtyinput');
      if (!input || input.disabled) return;

      // Support both +/- (data-dir) and +10 (data-delta)
      // Prefer data-dir when present (so the normal + button is always +1)
      let delta = 0;
      if (btn.dataset.dir != null && btn.dataset.dir !== '') {
        delta = parseInt(btn.dataset.dir, 10);
      } else if (btn.dataset.delta != null && btn.dataset.delta !== '') {
        delta = parseInt(btn.dataset.delta, 10);
      }
      if (Number.isNaN(delta) || delta === 0) return;

      const current = parseInt(input.value || '0', 10);
      const next = clampVariantQty(wrap, current + delta);

      input.value = String(next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    function shortVariantLabel(label) {
      if (!label) return '';
      const raw = String(label);
      const low = raw.toLowerCase();
      if (low.includes('box of')) {
        const m = raw.match(/box\s*of\s*(\d+)/i);
        return m ? `Box ${m[1]}` : 'Box';
      }
      if (low.includes('single')) return 'Single';
      if (low.includes('box')) return 'Box';
      // fallback: first 12 chars or first word
      const firstWord = raw.split(' ')[0];
      return firstWord.length <= 12 ? firstWord : raw.slice(0, 12);
    }

    /* =========================
       RECOMPUTE footer + per-line state
       ========================= */
    function recompute() {
      let selectedTotal = 0;

      qsa(list, '[data-qof-variant]').forEach(v => {
        const input = qs(v, '.egm-qof__qtyinput');
        const valEl = qs(v, '[data-qof-qtyvalue]');
        const lineBtn = qs(v, '[data-qof-lineadd]');
        const available = (v.dataset.available === 'true');

        const qty = input ? parseInt(input.value || '0', 10) : 0;
        if (qty > 0) selectedTotal += qty;

        if (valEl) valEl.textContent = String(qty);

        if (lineBtn) {
          lineBtn.textContent = lineAddLabel;
          lineBtn.disabled = (!available) || qty <= 0;
        }
      });

      getRows().forEach(row => {
        const variants = qsa(row, '[data-qof-variant]');
        const picked = [];
        let rowTotal = 0;

        variants.forEach(v => {
          const input = qs(v, '.egm-qof__qtyinput');
          const qty = input ? parseInt(input.value || '0', 10) : 0;
          if (!qty || qty <= 0) return;
          rowTotal += qty;

          const label = (v.dataset.variantLabel || '').trim() || (qs(v, '.egm-qof__variant-title')?.textContent || '').trim();
          const short = shortVariantLabel(label);
          const stockKnown = (v.dataset.stockKnown === '1');
          const stock = stockKnown ? String(parseInt(v.dataset.stock || '0', 10)) : '—';

          picked.push({ qty, label, short, stock, stockKnown });
        });

        const summaryEl = qs(row, '[data-qof-summary]');
        const stockEl = qs(row, '[data-qof-stock]');

        if (picked.length === 0) {
          if (summaryEl) {
            summaryEl.textContent = '—';
            summaryEl.removeAttribute('title');
          }
          if (stockEl) {
            stockEl.textContent = row.dataset.defaultStockDisplay || '—';
            stockEl.removeAttribute('title');
          }
          return;
        }

        if (summaryEl) {
          const all = picked.map(p => `${p.qty}× ${p.label}`).join(', ');
          let shown = picked.map(p => `${p.qty}× ${p.short || p.label}`);
          if (shown.length > 2) {
            const extra = shown.length - 2;
            shown = shown.slice(0, 2);
            shown.push(`+${extra}`);
          }
          summaryEl.textContent = shown.join(', ');
          summaryEl.title = all;
        }

        if (stockEl) {
          const allStock = picked.map(p => `${p.label}: ${p.stock}`).join(', ');

          if (picked.length === 1) {
            stockEl.textContent = picked[0].stock;
            stockEl.title = allStock;
          } else {
            let shownStock = picked.map(p => `${p.short || p.label} ${p.stock}`);
            if (shownStock.length > 2) {
              const extra = shownStock.length - 2;
              shownStock = shownStock.slice(0, 2);
              shownStock.push(`+${extra}`);
            }
            stockEl.textContent = shownStock.join(' · ');
            stockEl.title = allStock;
          }
        }
      });

      const readyTotal = cartCount + selectedTotal;

      if (countEl) countEl.textContent = String(readyTotal);
      if (addBtn) addBtn.disabled = (readyTotal === 0);
    }

    list.addEventListener('change', (e) => {
      if (e.target && e.target.classList.contains('egm-qof__qtyinput')) {
        const variant = e.target.closest('[data-qof-variant]');
        const n = parseInt(e.target.value || '0', 10);
        const next = clampVariantQty(variant, isNaN(n) ? 0 : n);
        e.target.value = String(next);
        recompute();
      }
    });

    /* =========================
       PER-VARIANT "Add to order"
       ========================= */
    list.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-qof-lineadd]');
      if (!btn) return;

      const wrap = btn.closest('[data-qof-variant]');
      if (!wrap) return;

      const input = qs(wrap, '.egm-qof__qtyinput');
      const id = wrap.dataset.variantId;
      let qty = input ? parseInt(input.value || '0', 10) : 0;
      qty = clampVariantQty(wrap, qty);
      if (input) input.value = String(qty);

      if (!id || qty <= 0 || btn.disabled) return;

      btn.disabled = true;
      btn.textContent = lineAddingLabel;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
        });

        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || 'Add failed');
        }

        // reset selezione (ora è in cart)
        input.value = '0';
        input.dispatchEvent(new Event('change', { bubbles: true }));

        await refreshCartUI();
        recompute();

        btn.textContent = lineAddedLabel;
        setTimeout(() => {
          btn.textContent = lineAddLabel;
          btn.disabled = false;
          recompute();
        }, 700);

      } catch (err) {
        alert(err.message || 'Error');
        btn.textContent = lineAddLabel;
        btn.disabled = false;
        recompute();
      }
    });

    /* =========================
       Search + filter (and then apply limit)
       ========================= */
    function applyFilters() {
      const term = (searchInput?.value || '').trim().toLowerCase();
      const discountActive = discountBtn?.classList.contains('is-active');

      getRows().forEach(row => {
        const title = row.dataset.title || '';
        const tags = row.dataset.tags || '';

        let ok = true;

        if (term) {
          const variantMatches = qsa(row, '[data-qof-variant]').some(v => {
            const vt = v.dataset.variantTitle || '';
            return vt.includes(term);
          });
          ok = title.includes(term) || variantMatches;
        }

        if (ok && discountActive && discountTag) {
          ok = tags.includes(discountTag);
        }

        row.dataset.qofMatch = ok ? '1' : '0';

        // base visibility for filters
        if (!ok) {
          row.style.display = 'none';
          row.dataset.qofLimited = '0';
        } else {
          row.style.display = '';
        }
      });

      // after filters, apply 3-rows limit unless expanded
      applyLimit();
    }

    searchInput?.addEventListener('input', () => {
      expanded = false; // quando cerchi, torna compatta a 3 risultati
      applyFilters();
    });

    discountBtn?.addEventListener('click', () => {
      discountBtn.classList.toggle('is-active');
      expanded = false;
      applyFilters();
    });

    /* =========================
       Clear (solo selezione, NON svuota carrello)
       ========================= */
       clearBtn?.addEventListener('click', async () => {
       // reset selezioni UI
       qsa(list, '.egm-qof__qtyinput').forEach(i => {
         if (!i.disabled) i.value = '0';
       });
       recompute();

       // ✅ svuota TUTTO il carrello Shopify
       try {
         await fetch('/cart/clear.js', {
           method: 'POST',
           headers: { 'Accept': 'application/json' }
         });

         // refresh UI (badge + drawer)
         await refreshCartUI();
         recompute();
       } catch (err) {
         console.error('Cart clear failed', err);
       }
     });


    /* =========================
       ORDER (footer)
       ========================= */
    addBtn?.addEventListener('click', async () => {
      const items = [];

      qsa(list, '[data-qof-variant]').forEach(v => {
        const id = v.dataset.variantId;
        const input = qs(v, '.egm-qof__qtyinput');
        if (!id || !input) return;
        let qty = parseInt(input.value || '0', 10);
        qty = clampVariantQty(v, qty);
        input.value = String(qty);
        if (qty > 0) items.push({ id: Number(id), quantity: qty });
      });

      addBtn.disabled = true;
      addBtn.textContent = orderingLabel;

      try {
        if (items.length) {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items })
          });

          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || 'Order failed');
          }

          qsa(list, '.egm-qof__qtyinput').forEach(i => { if (!i.disabled) i.value = '0'; });
        }

        await refreshCartUI();
        recompute();

        if (cartCount > 0) {
          window.location.href = '/checkout';
          return;
        }

        throw new Error('Cart is empty');

      } catch (e) {
        alert(e.message || 'Error');
        addBtn.disabled = false;
        addBtn.textContent = addDefaultLabel;
        recompute();
      }
    });

    /* =========================
       Cart drawer remove FIX (X button)
       ========================= */
    document.addEventListener('click', async (e) => {
      // intercetta click su possibili bottoni remove
      const removeBtn = e.target.closest(
        '[data-cart-remove], [data-cart-item-remove], button[name="remove"], button[data-remove], .cart-remove, .CartItem__Remove'
      );
      if (!removeBtn) return;

      // solo se dentro cart drawer
      const inDrawer = removeBtn.closest('#shopify-section-cart-drawer, .cart-drawer, cart-drawer, #CartDrawer');
      if (!inDrawer) return;

      // prova a prendere line o key
      let line = removeBtn.dataset.line || removeBtn.dataset.index;
      let key  = removeBtn.dataset.key || removeBtn.dataset.cartItemKey;

      // fallback: prova a cercare su parent
      if (!line) line = removeBtn.closest('[data-line]')?.dataset.line || removeBtn.closest('[data-index]')?.dataset.index;
      if (!key)  key  = removeBtn.closest('[data-key]')?.dataset.key  || removeBtn.closest('[data-cart-item-key]')?.dataset.cartItemKey;

      // se non trova niente, esci
      if (!line && !key) return;

      e.preventDefault();

      try {
        const payload = key
          ? { id: key, quantity: 0 }
          : { line: parseInt(line, 10), quantity: 0 };

        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        await refreshCartUI();
      } catch (err) {
        console.error('Remove from cart drawer failed', err);
      }
    });


    /* =========================
       INIT
       ========================= */
    (async function init() {
      await refreshCartUI();
      recompute();
      applyFilters();
      qsa(list, '[data-qof-toggle]').forEach(btn => setToggleState(btn, false));
    })();
  });
})();
